import store from '@/store';

const ClientOrderShow = () => import(/* webpackChunkName: "orders" */ './ClientOrderShow.vue');
const SupplierOrderShow = () => import(/* webpackChunkName: "orders" */ './SupplierOrderShow.vue');
const CLIENT = 'client';
const SUPPLIER = 'supplier';

export default {
  name: 'AccountOrderShow',
  functional: true,
  props: {
    accountId: [String],
    orderId: [String],
  },
  render(h, ctx) {
    const { type = CLIENT } = store.getters['ui/accounts/account'] || {};

    if (type === SUPPLIER) return h(SupplierOrderShow, ctx);
    return h(ClientOrderShow, ctx);
  },
};
